import { type Event } from '@kalos/kalos-rpc';
import { type QueryKey, useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { EventClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export const useCalendarDataQuery = (
  req: Event,
  options?: Partial<UseQueryOptions<any, Error, any, QueryKey>>,
) => {
  return useQuery({
    queryKey: [
      queryKeys.serviceCalendar.root,
      queryKeys.serviceCalendar.getServiceCalendarHash(req),
    ],
    queryFn: async () => {
      if (req.dateStarted != '') {
        return await EventClientService.GetCalendarData(req);
      }
    },
    ...options,
  });
};
